module.exports = __webpack_public_path__ + "static/holgernew.362d89c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/holgernew.jpg
// module id = 649
// module chunks = 35783957827783